// extracted by mini-css-extract-plugin
export default {"componenteNaoEncontrado":"NotFound_componenteNaoEncontrado__ndSl7"};